import { useSelector } from "react-redux";

import { selectFavoriteBarbers } from "../../ducks/user";

export const useFavoriteBarberIds = () => {
  const favoriteIds = useSelector(selectFavoriteBarbers);
  return favoriteIds;
};
